import useMasterChangeApprover from "../../hooks/useMasterChangeApprover";
import { willBeSentForApprovalMessage } from "../../lib/masterChange";

/**
 * WHERE THIS CONTROL SENDS THE THING, SAID BEFORE THE CONTROL IS PRESSED.
 *
 * Every master write files (A26/A28, D-006), and every confirm dialog in front
 * of one used to describe the END STATE in the PRESENT TENSE: "their sign-in is
 * revoked", "the unit disappears from every picker". None of that happens when
 * the button is pressed; a request is created and somebody else decides it. On
 * 24 August that sentence produced eleven duplicate filings against one user
 * over two days — Archive, Deactivate, Edit, each answering 200 and each
 * appearing to do nothing.
 *
 * ONE COMPONENT PER FACT. The fact is "who will receive this", and it is
 * resolved from the chain through `/master-changes/approver` — never a role
 * literal, which is wrong for the reciprocal branch today and wrong for
 * everybody the day the deep-hierarchy work lands.
 *
 * Renders NOTHING when the destination cannot be resolved. No fallback name and
 * no fallback role: a fallback is used precisely when the fetch failed, which is
 * the worst moment to guess who is about to receive somebody's request.
 */
export default function MasterChangeDestination({ testId }) {
  const { waitingOn } = useMasterChangeApprover();
  if (!waitingOn) return null;
  return (
    <span className="block font-semibold text-callisto-navy" data-testid={testId}>
      {willBeSentForApprovalMessage(waitingOn)}
    </span>
  );
}
